import {
    SHOW_SERIALHELP_OVERLAY,
    DISMISS_SERIALHELP_OVERLAY
} from '../constants';


export function showSerialHelpOverlay(payload) {
    return {
        type: SHOW_SERIALHELP_OVERLAY,
        payload: {}
    }
}

export function hideSerialHelpOverlay() {
    return {
        type: DISMISS_SERIALHELP_OVERLAY,
        payload: {}
    }
}



// WEBPACK FOOTER //
// ./src/actions/serialhelpoverlay.js